export default __webpack_public_path__ + "static/media/checkbox.478d565b.svg";